import HttpService from '../Services/HttpService';
import axios, {AxiosInstance} from 'axios';

import * as HTTP_HEADER from '../Constants/HttpHeaders';
import * as CONNECTION from '../Constants/Connection';
import * as DASHBOARD from '../Constants/Dashboard';
import moment from 'moment';

class StreamService extends HttpService {
  private _axios: AxiosInstance;


  getNewsStream = (page?: number, pageSize?: number) => {
    this.initAxios();
    const _getNewsApiUrl =
      this.buildStreamApiUrl(`${CONNECTION.STREAM_FEED}`, DASHBOARD.STREAM_NEWS, page, pageSize);
    return window.fetch(_getNewsApiUrl.toString());
  }

  getEventsStream = (page?: number, pageSize?: number) => {
    this.initAxios();
    const _getEventsApiUrl =
      this.buildStreamApiUrl(`${CONNECTION.STREAM_FEED}`, DASHBOARD.STREAM_EVENTS, page, pageSize);
    return window.fetch(_getEventsApiUrl.toString());
  }

  getArticle = (path: string) =>{
    this.initAxios();
    return window.fetch(`${window.appSettings.aemStreamUrl}${CONNECTION.STREAM_SINGLE}${path}`);
  }

  private buildStreamApiUrl(apiUrl: string, streamType: string, page?: number, pageSize?: number) {
    let queryParams: string[] = [];

    if ((page || page === 0) && pageSize) { queryParams.push(`${CONNECTION.STREAM_PAGE_START}=${page*pageSize};`); }
    if (pageSize) { queryParams.push(`${CONNECTION.STREAM_PAGE_SIZE}=${pageSize};`); }
    if(streamType == 'events') { queryParams.push(`currentDate=${moment().format()};`)}

    if (queryParams.length > 0) {
      return `${window.appSettings.aemStreamUrl}${apiUrl}${queryParams.join('')}type=${streamType};`;
    } else {
      return apiUrl;
    }

  }
  private initAxios(){
    if(!this._axios){
      this._axios = axios.create({
        timeout: HTTP_HEADER.TIMEOUT_IN_MILLISECONDS
      })
    }
  }
}

export default StreamService;